module.exports = __webpack_public_path__ + "img/29139473000156.39d8c2b8.png";